import { InjectionToken } from '@angular/core';
import { MojoEditorService } from 'mojo-editor/lib/mojo-editor.config';

export const EDITOR_SERVICE = new InjectionToken<MojoEditorService>('MojoEditorService');
